import { Checkbox } from '@mui/material';
import { OnlyFansSubscriberHostessAutoReplyFreeloaders } from '../../../../types/hostessAutoReplyFreeloaders';

const FormAutoUnrestrictWhenSpendingCheckbox = (props: {
    formData: OnlyFansSubscriberHostessAutoReplyFreeloaders;
    setFormData: (formData: OnlyFansSubscriberHostessAutoReplyFreeloaders) => void;
}) => {
    const { formData, setFormData } = props;

    return (
        <Checkbox
            checked={formData && formData.autoUnrestrict ? true : false}
            disabled={formData && formData.action !== 'restrict' && formData.action !== 'mute' ? true : false}
            size="medium"
            onChange={e => {
                setFormData({ ...formData, autoUnrestrict: e.target.checked });
            }}
            sx={{
                '& .MuiSvgIcon-root': {
                    fontSize: '1.5rem',
                },
            }}
        />
    );
};

export default FormAutoUnrestrictWhenSpendingCheckbox;
